var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointments1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00c8d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.001h-15a2.5 2.5 0 0 1-1.768-.732 2.5 2.5 0 0 1-.542-.811 2.5 2.5 0 0 1-.19-.957v-19A2.5 2.5 0 0 1 2.5 0h15A2.5 2.5 0 0 1 20 2.5v19a2.5 2.5 0 0 1-.732 1.768c-.232.232-.508.416-.811.542a2.5 2.5 0 0 1-.957.19h0zM2.5 1A1.5 1.5 0 0 0 1 2.5v19a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 17.5 1h-15z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -3.001
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -12.001
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M16.5 19.001h-13a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments1);
export default __webpack_public_path__ + "static/media/appointments1.d2d623230c4de3cc4f2dec586a39b1c5.svg";
export { ForwardRef as ReactComponent };